"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
const RefForwarding = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/(0, _react.cloneElement)(children, {
    forwardedRef: ref
  });
});
var _default = exports.default = RefForwarding;